import { useQuery } from '@tanstack/react-query'
import { supabaseApi } from '~/supabase/api'

export const GET_BUCKET_PHOTOS_QUERY_KEY = 'get-bucket-photos'

export const useBucketPhotos = () => {
  return useQuery({
    queryKey: [GET_BUCKET_PHOTOS_QUERY_KEY],
    queryFn: async () => {
      const { data, error } = await supabaseApi.from('all_photos').select('*')
      if (error) throw error
      return data
    },
    refetchOnWindowFocus: false,
  })
}
